module.exports = __webpack_public_path__ + "img/milano-logo.8b8ad7f.svg";